import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonNavBar } from './NavBar.definition';
import { chameleonTooltip } from '../Tooltip/Tooltip.definition';
import { chameleonNavBarItem } from './NavBarItem/NavBarItem.definition';
import { chameleonSvg } from '../Svg';
import { chameleonButton } from '../Button/Button.definition';
import { chameleonPopover } from '../Popover/Popover.definition';
provideChameleonDesignSystem().register(chameleonNavBar(), chameleonNavBarItem(), chameleonTooltip(), chameleonSvg(), chameleonButton(), chameleonPopover());
